namespace Matrix.Data {
    export class AccountGroupAccountColumns {
        static columnsKey = 'Data.AccountGroupAccount';
    }
}
